import { render, staticRenderFns } from "./DatenschutzPage.vue?vue&type=template&id=1e565c6c&"
import script from "./DatenschutzPage.vue?vue&type=script&lang=js&"
export * from "./DatenschutzPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports